<template>
  <el-table :data="items" size="small">
    <el-table-column
      prop="pit_number"
      align="center"
      label="井号"
    ></el-table-column>
    <el-table-column
      prop="pit_team"
      label="井队"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="region_info.name"
      label="区域"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="service"
      label="服务内容"
      align="center"
    ></el-table-column>
    <el-table-column prop="show_start_time" label="服务开始日期" align="center">
      <template slot-scope="scope">
        {{
          scope.row.start_time
            ? $time(scope.row.start_time).format('YYYY-MM-DD')
            : ''
        }}
      </template>
    </el-table-column>
    <el-table-column label="服务人员" align="center">
      <template slot-scope="scope">
        <div v-for="user in scope.row.users" :key="user.id">
          {{ user.user.name }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="日报数量" align="center">
      <template slot-scope="scope">
        <router-link
          :to="`/report/reports?project_id=${scope.row.id}`"
          class="text-primary"
          >{{ scope.row.reports.length }}</router-link
        >
      </template>
    </el-table-column>
    <el-table-column prop="pit_number" label="钻头趟数" align="center">
      <template slot-scope="scope">
        <router-link
          :to="`/report/drill_trips?project_id=${scope.row.id}`"
          class="text-primary"
          >{{ scope.row.drill_trips.length }}</router-link
        >
      </template>
    </el-table-column>
    <el-table-column
      prop="pit_number"
      label="井及状态"
      align="center"
      v-if="!archive"
    >
      <template slot-scope="scope">
        <el-tag size="mini" type="primary">
          {{ ProjectDrillStatusMap[scope.row.status] }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="150" align="center">
      <template slot-scope="scope">
        <template v-if="!archive">
          <el-button
            v-code="24101"
            type="text"
            size="mini"
            @click="
              $router.push(`/report/reports/new?project_id=${scope.row.id}`)
            "
            >添加日报</el-button
          >
          <el-button
            v-code="21103"
            type="text"
            size="mini"
            @click="$router.push(`/report/projects/${scope.row.id}/edit`)"
            >编辑</el-button
          >
          <el-button
            v-code="21102"
            type="text"
            size="mini"
            @click="$router.push(`/report/projects/${scope.row.id}`)"
            >详情</el-button
          >
          <el-popconfirm
            v-code="21104"
            title="确定删除该项目吗？"
            @confirm="handleDelete(scope.row.id, scope.$index)"
          >
            <el-button
              slot="reference"
              type="text"
              size="mini"
              class="text-danger mr-10"
              >删除</el-button
            >
          </el-popconfirm>
          <el-popconfirm
            v-code="21105"
            title="确定归档该项目吗？"
            @confirm="handleArchive(scope.row.id, scope.$index)"
          >
            <el-button
              slot="reference"
              type="text"
              size="mini"
              class="text-danger mr-10"
              >归档</el-button
            >
          </el-popconfirm>
        </template>
        <el-button
          v-code="21102"
          v-if="archive"
          type="text"
          size="mini"
          @click="$router.push(`/report/archive_projects/${scope.row.id}`)"
          >详情</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { projectArchive, projectDelete } from '@/service/getData'
import { ProjectDrillStatusMap } from '@/config/global'

export default {
  props: {
    items: null,
    archive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ProjectDrillStatusMap,
    }
  },
  methods: {
    async handleArchive(id, index) {
      let res = await projectArchive(id)
      if (res.code == 0) {
        this.items.splice(index, 1)
        this.$message({
          message: '归档成功！',
          type: 'success',
        })
      }
    },

    async handleDelete(id, index) {
      let res = await projectDelete(id)
      if (res.code == 0) {
        this.items.splice(index, 1)
      }
    },
  },
}
</script>